import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { all_routes } from '../../../router/all_routes'
import StudentModals from '../studentModals'
import StudentSidebar from './studentSidebar'
import StudentBreadcrumb from './studentBreadcrumb'
import UserService from '../../../network/services/UserService'
import { getUser } from '../../../network/auth/Auth'
import moment from 'moment'

const StudentTimeTable = () => {




    interface TimetableData {
        id: any;
        name: any;
        days: any;
        sessions: any;
        code: any;
        parent_id: any;
        evaluation_type: any;
        subject_ids: any;
        department_id: any;
        active: any;
        fees_term_id: any;
        operating_branch_id: any;
        company_id: any

    }
    const [timetables, setTimetables] = useState<TimetableData[]>([]);

    const fetchData = async (company_id: any, course_id: any) => {
        UserService.getTimetableSearch(company_id, course_id, (response: any) => {
            if (response?.data && response?.success) {
                console.log(response.data);
                setTimetables(response.data)


            }
        });
    };

    const fetchDataUser = async (student_id: any) => {
        UserService.getAdmissionCourse(student_id, (response: any) => {
            if (response?.data && response?.success) {
                console.log(response.data);
                if (response?.data[0]?.courses[0]) {
                    fetchData(getUser()?.company_ids[0]?.id, response?.data[0]?.courses[0]?.id);
                }


            }
        });
    };

    const navigation = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location?.state) {
            fetchDataUser(location?.state?.student?.id)


        }
    }, []);

    const navigeStudentDetails = (student: any) => {
        navigation(routes.studentDetail, { state: { student: student } })
    }

    const navigeStudentTimeline = (student: any) => {
        navigation(routes.studentTimeTable, { state: { student: student } })
    }

    const navigeStudentLeaves = (student: any) => {
        navigation(routes.studentLeaves, { state: { student: student } })
    }
    const navigeStudentExam = (student: any) => {
        navigation(routes.studentResult, { state: { student: student } })
    }




    const getTimeRange = (name: any) => {
        const timeRangePattern = /\d{1,2}:\d{2}[AP]M-\d{1,2}:\d{2}[AP]M/;
        const match = name.match(timeRangePattern);

        return match ? match[0] : null; // Retourne la plage horaire ou null si non trouvée
    };

    const routes = all_routes
    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        {/* Page Header */}
                        <StudentBreadcrumb />
                        {/* /Page Header */}
                    </div>
                    <div className="row">
                        {/* Student Information */}
                        <StudentSidebar student={location?.state?.student} />
                        {/* /Student Information */}
                        <div className="col-xxl-9 col-xl-8">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* List */}
                                    <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                                        <li>
                                            <a onClick={() => navigeStudentDetails(location?.state?.student)} className="nav-link active">
                                                <i className="ti ti-school me-2" />
                                                Student Details
                                            </a>
                                        </li>
                                        <li>
                                            <a onClick={() => navigeStudentTimeline(location?.state?.student)} className="nav-link active">
                                                <i className="ti ti-table-options me-2" />
                                                Time Table
                                            </a>
                                        </li>
                                        <li>
                                            <a onClick={() => navigeStudentLeaves(location?.state?.student)} className="nav-link active">
                                                <i className="ti ti-calendar-due me-2" />
                                                Attendance
                                            </a>
                                        </li>

                                        <li>
                                            <a onClick={() => navigeStudentExam(location?.state?.student)} className="nav-link active">
                                                <i className="ti ti-bookmark-edit me-2" />
                                                Exam &amp; Results
                                            </a>
                                        </li>
                                    </ul>
                                    {/* /List */}
                                    <div className="card">
                                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                                            <h4 className="mb-3">Time Table</h4>
                                            <div className="d-flex align-items-center flex-wrap">
                                                <div className="dropdown mb-3">
                                                    <Link
                                                        to="#"
                                                        className="btn btn-outline-light border-white bg-white dropdown-toggle shadow-md"
                                                        data-bs-toggle="dropdown"
                                                    >
                                                        <i className="ti ti-calendar-due me-2" />
                                                        This Year
                                                    </Link>
                                                    <ul className="dropdown-menu p-3">
                                                        <li>
                                                            <Link
                                                                to="#"
                                                                className="dropdown-item rounded-1"
                                                            >
                                                                This Year
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link
                                                                to="#"
                                                                className="dropdown-item rounded-1"
                                                            >
                                                                This Month
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link
                                                                to="#"
                                                                className="dropdown-item rounded-1"
                                                            >
                                                                This Week
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body pb-0">
                                            <div className="d-flex flex-nowrap overflow-auto">

                                                {timetables && timetables?.map((item: any, index: any) => (
                                                    <div className="d-flex flex-column me-4 flex-fill" key={index}>
                                                        <div className="mb-3">
                                                            <h6>{item?.day}</h6>
                                                        </div>

                                                        {item?.sessions && item?.sessions.map((item: any, index: any) => (
                                                            <div className="bg-transparent-light rounded p-3 mb-4" key={index}>
                                                                <p className="d-flex align-items-center text-nowrap mb-1">
                                                                    <i className="ti ti-calendar me-1" />
                                                                    {item?.start_datetime ? moment(item?.start_datetime).format('ddd DD MMM YYYY') : ""}
                                                                </p>
                                                                <p className="d-flex align-items-center text-nowrap mb-1">
                                                                    <i className="ti ti-clock me-1" />
                                                                    {item?.name ? getTimeRange(item?.name) : ""}
                                                                </p>

                                                                <p className="text-dark">Subject : {item?.subject_id.name}</p>
                                                                <div className="bg-white rounded p-1 mt-3">
                                                                    <Link
                                                                        to={routes.teacherDetails}
                                                                        className="text-muted d-flex align-items-center"
                                                                    >
                                                                        <span className="avatar avatar-sm me-2">
                                                                            <img
                                                                                src={`data:image/png;base64,${item?.faculty_id?.partner_id?.avatar}`}
                                                                                alt="Img"
                                                                            />
                                                                        </span>
                                                                        {item?.faculty_id?.partner_id?.name}
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        ))}

                                                    </div>))}



                                            </div>
                                        </div>
                                        <div className="card-footer border-0 pb-0">
                                            <div className="row">
                                                <div className="col-lg-4 col-xxl-4 col-xl-4 d-flex">
                                                    <div className="card flex-fill">
                                                        <div className="card-body">
                                                            <span className="bg-primary badge badge-sm mb-2">
                                                                Morning Break
                                                            </span>
                                                            <p className="text-dark">
                                                                <i className="ti ti-clock me-1" />
                                                                10:30 to 10 :45 AM
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-xxl-3 d-flex">
                                                    <div className="card flex-fill">
                                                        <div className="card-body">
                                                            <span className="bg-warning badge badge-sm mb-2">Lunch</span>
                                                            <p className="text-dark">
                                                                <i className="ti ti-clock me-1" />
                                                                10:30 to 10 :45 AM
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-xxl-3 d-flex">
                                                    <div className="card flex-fill">
                                                        <div className="card-body">
                                                            <span className="bg-info badge badge-sm mb-2">
                                                                Evening Break
                                                            </span>
                                                            <p className="text-dark">
                                                                <i className="ti ti-clock me-1" />
                                                                03:30 PM to 03:45 PM
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* /Page Wrapper */}
            <StudentModals />
        </>

    )
}

export default StudentTimeTable